module.exports = __webpack_public_path__ + "img/chinesecompany207.6808b119.png";